/** Mirrors the backend `StrefyErrorCode` (contract WKD-2488 §9) — only the codes the zones and passages screens react to. */
export enum StrefyErrorCode {
  STREFA_NIE_ISTNIEJE = 'STREFA_NIE_ISTNIEJE',
  STREFA_KOD_DUPLIKAT = 'STREFA_KOD_DUPLIKAT',
  STREFA_MAX_POZIOM = 'STREFA_MAX_POZIOM',
  STREFA_KORZEN = 'STREFA_KORZEN',
  STREFA_KORZEN_ZAJETY = 'STREFA_KORZEN_ZAJETY',
  STREFA_MA_PODSTREFY = 'STREFA_MA_PODSTREFY',
  PRZEJSCIE_NIE_ISTNIEJE = 'PRZEJSCIE_NIE_ISTNIEJE',
  PRZEJSCIE_ZA_MALO_STREF = 'PRZEJSCIE_ZA_MALO_STREF',
  PRZEJSCIE_TE_SAME_STREFY = 'PRZEJSCIE_TE_SAME_STREFY',
  PRZEJSCIE_TKD_STATUS = 'PRZEJSCIE_TKD_STATUS',
  PRZEJSCIE_TKD_SEKWENCJA = 'PRZEJSCIE_TKD_SEKWENCJA',
  PRZEJSCIE_DUPLIKAT = 'PRZEJSCIE_DUPLIKAT',
  TKD_NIE_ISTNIEJE = 'TKD_NIE_ISTNIEJE',
  MONITORING_AKTYWNY = 'MONITORING_AKTYWNY',
}

/** Direction of a przejście — the event mod, not the boolean `tkd.mod` (contract R2, §8). */
export enum PrzejscieModEnum {
  WEJSCIE = 'WEJSCIE',
  WYJSCIE = 'WYJSCIE',
}

export enum PrzejscieModDescriptionEnum {
  WEJSCIE = 'definitions.passages.mod.WEJSCIE',
  WYJSCIE = 'definitions.passages.mod.WYJSCIE',
}

/** Sortable columns of `GET /przejscie` (contract §2). */
export enum PrzejscieSortByEnum {
  NUMER_LOGICZNY_KONTROLERA = 'numerLogicznyKontrolera',
  NAZWA_TKD = 'nazwaTkd',
  STREFA_POCZATKOWA = 'strefaPoczatkowa',
  STREFA_KONCOWA = 'strefaKoncowa',
}

/** A przejście needs at least two zones, the predefined root included (contract §2 `PRZEJSCIE_ZA_MALO_STREF`, D11). */
export const PRZEJSCIE_MIN_STREF = 2;

/** Predefined root zone (`kod "0"`, `nazwa "---"`) — cannot be deleted (contract R1). */
export const STREFA_ROOT_ID = '00000000-0000-4000-8000-00000000c001';

/** Deepest level of the structure, the root being level 1 (contract §8). */
export const STREFA_MAX_POZIOM = 4;

export const STREFA_KOD_MAX_DLUGOSC = 20;

export const STREFA_NAZWA_MAX_DLUGOSC = 60;
